<div class="fixed inset-0 z-[9999] flex justify-center bg-black/50 overflow-y-auto no-scrollbar p-4 md:p-10">
    <div class="my-auto flex flex-col gap-5 relative bg-white rounded-[15px] p-6 w-full max-w-[480px]">
        <button (click)="close.emit()"
            class="w-7 h-7 flex items-center justify-center text-black cursor-pointer absolute right-3 top-3 rounded-full bg-light-black-100 hover:bg-black hover:text-white duration-200 ease-in-out">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.0423 0.708008L0.70975 12.0406M12.0416 12.0413L0.708984 0.708811" stroke="currentColor"
                    stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
        <!-- modal content -->
        <div class="flex flex-col gap-5">
            <h2 class="text-black text-xl lg:text-2xl !leading-5 font-bold text-center">Sell {{ position?.team ||
                'Position' }}</h2>

            <div class="flex items-center justify-center flex-col gap-5">
                <img [src]="position?.image || 'assets/images/leaderboard/sellno-modal-image.png'" alt="market-image"
                    class="w-full h-[180px] object-cover rounded-xl" />
                <h3 class="text-black text-base md:text-lg lg:text-xl font-medium">{{ position?.question || 'Market
                    Question' }}</h3>
            </div>

            <div class="flex flex-col items-center justify-center gap-5 bg-light-black-300 rounded-xl p-5">
                <p class="flex items-start gap-2 text-lg text-black font-medium !leading-3">
                    Current Value <span class="text-[22px] !leading-4 text-primary-text-green">{{ displayValue }}</span>
                </p>
                <p class="text-lg font-medium text-secondary-text-black !leading-3">{{ displayShares }} &#64; {{
                    displayNow }}</p>
            </div>
            <div class="grid grid-cols-2 gap-3">
                <button (click)="onCashout()" [disabled]="!isCashEnabled || isProcessing"
                    class="w-full flex items-center justify-center gap-2 text-sm font-syne font-semibold border border-transparent rounded-lg cursor-pointer duration-200 ease-in-out pt-3 pb-2.5 px-4"
                    [ngClass]="isCashEnabled && !isProcessing ? 'bg-primary-text-green text-white hover:bg-primarybg-green hover:text-primary-text-green hover:border-primary-text-green' : 'bg-gray-400 cursor-not-allowed opacity-50 text-white'">
                    {{ isProcessing ? 'Processing...' : 'Cash out' }}
                </button>
                <button (click)="editOrder.emit()"
                    class="w-full flex items-start justify-center gap-2 text-sm font-syne font-semibold text-black bg-secondary-button-black border-black hover:bg-black hover:text-white hover:border-transparent rounded-lg cursor-pointer duration-200 ease-in-out pt-3 pb-2.5 px-4">
                    Edit order
                </button>
            </div>
        </div>
    </div>
</div>